import React, { useEffect, useState } from "react";
import PageTitle from "../../../Module/pageTitle";
import Dropdown from "../../../Component/dropdown";
import LabelField from "../../../Component/labelField";
import { useDispatch } from "react-redux";
import { campaignImageUpload, createCampaignID, getSourcesList } from "../../../Action/actionFile";
import DatePicker from "../../../Component/datePicker";
import InputField from "../../../Component/inputField";
import { use } from "react";
import {
  getBatchName,
  getExamListForWhatsapp,
  getExamListNew,
  getParentCourseNew,
} from "../../../Action/courseAction";
import {
  getExamStream,
  getExamWithState,
  getSubExam,
  getSubExamNew,
} from "../../../Action/adminPanelAction";
import {
  pdf_size_1MB,
  validateIsFileImageType,
  validateValueWithoutSpace,
} from "../../../Utils/validators";
import { Tooltip } from "@mui/material";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
} from "../../../Action/snackbarAction";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
function AddCampaignID() {
  const dispatch = useDispatch();
  const [source, setSource] = useState("");
  const [sourceList, setSourceList] = useState([]);
  const [date, setDate] = useState([]);
  const [campaignName, setCampaignName] = useState("");
  const [campaignId, setCampaignId] = useState("");

  const [examList, setExamList] = useState([]);
  const [examName, setExamName] = useState("");
  const [allExamStreamList, setAllExamStreamList] = useState([]);
  const [parentCourseList, setParentCourseList] = useState([]);
  const [parentCourseVal, setParentCourseVal] = useState("");
  const [examStreamSEOname, setExamStreamSEOname] = useState("");

  const [subExamList, setSubExamList] = useState([]);
  const [subExamName, setSubExamName] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [budget, setBudget] = useState(0);

  const [message, setMessage] = useState("");
  const [remark, setRemark] = useState("");
  const [imageUrl, setImageurl] = useState("");
  const [photoView, setPhotoView] = useState("");

  const sectionList = [
    {
      _id: 1,
      name: "Online Course",
    },
    {
      _id: 3,
      name: "Test Series",
    },
    {
      _id: 6,
      name: "Crash Course",
    },
  ];
  const [section, setSection] = useState("");
  const [batchList, setBatchList] = useState([]);
  const [filterBatchList, setFilterBatchList] = useState([]);
  const [batch, setBatch] = useState("");
  const subCategoryList = [
    {
      _id: "6433e3468fb2f655c0e62dfe",
      name: "COMPLETE STUDY MATERIAL",
    },
    {
      _id: "6433e37f8fb2f655c0e62e5c",
      name: "WITHOUT STUDY MATERIAL",
    },
  ];
  const [subCategory, setSubCategory] = useState("");
  const [duration, setDuration] = useState("");
  const [coupon, setCoupon] = useState("");
  const [url, setURL] = useState("");
  useEffect(() => {
    dispatch(
      getExamWithState((res) => {
        setExamList(res);
      }),
    );
    dispatch(
      getSourcesList((res) => {
        setSourceList(res?.data || []);
      }),
    );
    dispatch(
      getExamStream((res) => {
        setAllExamStreamList(res);
      }),
    );
  }, []);

  const onSourceChange = (data) => {
    setSource(data);
  };
  const onChangeCampaign = (val) => {
    setCampaignName(val);
  };
  const validateCampaign = () => {
    return campaignName === "" || date === "" || source === "";
  };
  const validate = () => {
    return (
      examName === "" ||
      parentCourseVal === "" ||
      section === "" ||
      batch === ""
    );
  };
  const submitCampaign = (step) => {
    const postData = {
      name: campaignName,
      date: date,
      source: source?.name,
    };

    if (totalCount) {
      postData.count = totalCount;
    }
    if (budget) {
      postData.budget = budget;
    }
    if (imageUrl) {
      postData.image = imageUrl;
    }
    if (remark) {
      postData.remark = remark;
    }
    if (message) {
      postData.message = message;
    }
    if (examName) {
      postData.examTypeId = examName?._id;
    }
    if (parentCourseVal) {
      postData.baseCourseId = parentCourseVal?._id;
    }
    if (campaignId) {
      postData.campaignId = campaignId;
    }
    if (subExamName) {
      postData.subExamTypeId = subExamName?._id;
    }
    if (duration) {
      postData.duration = duration;
    }
    if (batch) {
      postData.courseId = batch?._id;
    }
    if (coupon) {
      postData.coupon = coupon;
    }
    if (subCategory) {
      postData.subCatgetory = subCategory?.name; // consider fixing typo -> subCategory
    }
    if (url && step === "step2") {
      postData.url = url;
    }

    dispatch(
      createCampaignID(
        postData,
        (res) => {
          setCampaignId(res?.data?.campaignId || "");
          if (step === "step2") {
            // Clear all form fields after successful submit
            setCampaignName("");
            setDate("");
            setSource(null);
            setExamName(null);
            setParentCourseList([]);
            setParentCourseVal(null);
            setSubExamList([]);
            setSubExamName(null);
            setDuration("");
            setBatchList([]);
            setBatch(null);
            setCoupon("");
            setSubCategory(null);
            setUrl("");
          }
        },
        () => {},
      ),
    );
  };
  const onChangeExamName = (value) => {
    setExamName(value);
    setParentCourseVal("");
    setParentCourseList([]);
    setSubExamList([]);
    setSubExamName("");
    dispatch(
      getSubExamNew({ examTypeId: value?._id }, (res) => {
        if (res.data?.data?.length > 0) {
          setSubExamList(res.data?.data);
        } else {
          dispatch(
            getParentCourseNew(`${value._id}`, (res) => {
              setParentCourseList(res);
            }),
          );
        }
      }),
    );
  };
  const onChangeSubExam = (value) => {
    setSubExamName(value);
    dispatch(
      getParentCourseNew(`${examName._id}/${value._id}`, (res) => {
        setParentCourseList(res);
      }),
    );
  };
  const onChangeParentCourse = (value) => {
    setParentCourseVal(value);
    const filterExamStream = allExamStreamList?.filter(
      (item) => item?._id === value?._id,
    );
    if (filterExamStream && filterExamStream?.length > 0) {
      setExamStreamSEOname(filterExamStream[0]?.seoName);
    }
    const postData = {
      examTypeId: examName?._id,
      baseCourseId: value?._id,
    };
    if (subExamName?._id) postData.subExamTypeId = subExamName?._id;
    if (value) {
      dispatch(
        getBatchName(
          postData,
          (res) => {
            setBatchList(res.data);
          },
          () => {},
        ),
      );
    }
  };
const handleOptionImageChange = (e) => {
  e.preventDefault();

  const file = e.target.files?.[0];

  if (!file) return;

  if (!validateIsFileImageType(e)) {
    dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
    return;
  }

  if (file.size > pdf_size_1MB) {
    dispatch(showErrorSnackbar("File size should be less than 1 MB."));
    return;
  }

  const reader = new FileReader();

  reader.onloadend = () => {
    setPhotoView(reader.result);
  };

  reader.readAsDataURL(file);

  dispatch(
    campaignImageUpload(
      file,
      (res) => {
        setImageurl(res?.fullPath);
      },
      () => {}
    )
  );
};
  const onChangeSection = (value) => {
    setSection(value);
    const filter = batchList?.filter(
      (item) => item?.sectionType === value?._id && item?.status === 1,
    );
    setFilterBatchList(filter);
  };

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_DEV_FRONTEND_URL;
    const seoName = subExamName?.seoName
      ? subExamName?.seoName
      : examName?.seoName;
    const path = `${baseUrl}/${seoName}/${examStreamSEOname}${section?._id === 6 ? "-online-crash-courses" : section?._id === 3 ? "-online-test-series" : "-online-courses"}/${batch?._id}`;

    const params = new URLSearchParams();
    const subCategoryName =
      subCategory?.name === "COMPLETE STUDY MATERIAL"
        ? "complete-material"
        : "without-material";
    if (subCategory) params.set("variant", subCategoryName);
    if (duration) params.set("duration", duration);
    if (coupon) params.set("coupon", coupon);
    params.set("source", source?.name);
    params.set("campaignId", campaignId);

    const url = `${path}?${params.toString()}`;
    setURL(url);

  }, [
    examName,
    subExamName,
    parentCourseVal,
    examStreamSEOname,
    section,
    batch,
    subCategory,
    duration,
    coupon,
  ]);

  const handleTextChange = (e, setState) => {
    let value = e.target.value;

    value = value.replace(/^\s+/, "");

    value = value.replace(/\s{2,}/g, " ");

    setState(value);
  };
  return (
    <div>
      <div className="contentBox">
        <PageTitle name={"ADD CAMPAIGN ID"} />
        <div className="formDiv contentScrollbar">
          <div className="col-12 formWidth">
            <div className="col-md-6 d-flex mb-2 align-items-center">
              <LabelField labelName={"Source"} isRequired />
              <Dropdown
                setInputText={(value) => onSourceChange(value)}
                value={source}
                options={sourceList}
                labelName="Select Source"
                Isrequired={true}
              />
            </div>
            <div className="col-md-6 d-flex mb-2 align-items-center">
              <LabelField labelName={"Date"} isRequired />
              <DatePicker
                setInputText={(value) => setDate(value)}
                value={date}
                disabled={campaignId}
              />
            </div>
            <div className="col-md-6 d-flex mb-2 align-items-center">
              <LabelField labelName={"Campaign Name"} isRequired />
              <InputField
                // labelName={"Campaign Name"}
                placeholder={"Campaign Name"}
                setInputText={(value) => onChangeCampaign(value)}
                value={campaignName}
                Isrequired={true}
                disabled={campaignId}
              />
            </div>
            {!campaignId && (
              <div className="col-md-6 d-flex mb-2 align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={validateCampaign()}
                  onClick={() => submitCampaign("step1")}
                >
                  Create Campaign
                </button>
              </div>
            )}
            {/* {campaignId && ( */}
              <>
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName="Total User Count" />

                  <InputField
                    placeholder="Enter Total User Count"
                    setInputText={(value) => {
                      const numericValue = String(value)
                        .replace(/\D/g, "")
                        .slice(0, 7);

                      setTotalCount(numericValue);
                    }}
                    value={totalCount}
                    maxlength={7}
                  />
                </div>

                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName="Budget" />

                  <InputField
                    placeholder="Enter Budget"
                    setInputText={(value) => {
                      const numericValue = String(value)
                        .replace(/\D/g, "")
                        .slice(0, 5);

                      setBudget(numericValue);
                    }}
                    value={budget}
                    maxlength={5}
                  />
                </div>
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Exam Name"} isRequired={true} />
                  <Dropdown
                    setInputText={(value) => onChangeExamName(value)}
                    value={examName}
                    options={examList}
                    labelName="Select Exam Name"
                  />
                </div>
                {subExamList?.length > 0 ? (
                  <div className="col-md-6 d-flex mb-2 align-items-center">
                    <LabelField labelName={"Sub Exam Name"} isRequired={true} />
                    <Dropdown
                      labelName={"Sub Exam Name"}
                      placeholder={"select Sub Exam name"}
                      setInputText={(value) => onChangeSubExam(value)}
                      value={subExamName}
                      options={subExamList}
                    />
                  </div>
                ) : null}
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Exam Stream"} isRequired={true} />
                  <Dropdown
                    setInputText={(value) => onChangeParentCourse(value)}
                    value={parentCourseVal}
                    options={parentCourseList}
                    labelName="Select Exam Stream"
                  />
                </div>
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Section"} isRequired={true} />
                  <Dropdown
                    setInputText={(value) => onChangeSection(value)}
                    value={section}
                    options={sectionList}
                    labelName="Select Section"
                  />
                </div>
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Batch Name"} isRequired={true} />
                  <Dropdown
                    setInputText={(value) => setBatch(value)}
                    value={batch}
                    options={filterBatchList}
                    labelName="Select Batch Name"
                  />
                </div>
                {section?._id === 1 && (
                  <div className="col-md-6 d-flex mb-2 align-items-center">
                    <LabelField labelName={"Sub Category"} isRequired={true} />
                    <Dropdown
                      setInputText={(value) => setSubCategory(value)}
                      value={subCategory}
                      options={subCategoryList}
                      labelName="Select Sub Category"
                    />
                  </div>
                )}
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Duration"} />
                  <InputField
                    // labelName={"Campaign Name"}
                    placeholder={"Duration in Month"}
                    setInputText={(value) => setDuration(value)}
                    value={duration}
                  />
                </div>
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Coupon"} />
                  <InputField
                    // labelName={"Campaign Name"}
                    placeholder={"Coupon Name"}
                    setInputText={(value) => setCoupon(value)}
                    value={coupon}
                  />
                </div>
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Upload Images"} />
                  <ImagePickerAndViewer
                    value={photoView || imageUrl}
                    handleChange={(e) => handleOptionImageChange(e)}
                  />
                </div>
                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Remarks"} />
                  <textarea
                    className=" form-control w-100"
                    onChange={(e) => handleTextChange(e, setRemark)}
                    placeholder="Enter Remarks"
                    value={remark}
                    maxLength={500}
                  />
                </div>

                <div className="col-md-6 d-flex mb-2 align-items-center">
                  <LabelField labelName={"Message"} />
                  <textarea
                    className=" form-control w-100"
                    onChange={(e) => handleTextChange(e, setMessage)}
                    placeholder="Enter Message"
                    value={message}
                    maxLength={1000}
                  />
                </div>
                <div className="col-md-12 d-flex mb-2 align-items-center">
                  <LabelField labelName={"URL"} />
                  <div className="fw-bold">{url}</div>
                  <Tooltip title="Copy" arrow>
                    <ContentCopyRoundedIcon
                      color="primary"
                      className="cursor ms-2"
                      onClick={() => {
                        navigator.clipboard.writeText(url);
                        dispatch(showSuccessSnackbar("URL copied!"));
                      }}
                    />
                  </Tooltip>
                  {/* <InputField
                                    // labelName={"Campaign Name"}
                                    placeholder={"URL"}
                                    setInputText={(value) => setURL(value)}
                                    value={url}
                                    disabled={true}
                                /> */}
                </div>
                <div className="col-md-6 d-flex mb-2 align-items-center justify-content-end">
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={validate()}
                    onClick={() => submitCampaign("step2")}
                  >
                    Submit
                  </button>
                </div>
              </>
            {/* // )} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddCampaignID;
